import React from "react";
import ForgottenUserData from "../../ForgottenUserData";
import { forgottenPassword } from "../../../../../../axios/api/services";

const ForgottenPassword = () => {
  return (
    <ForgottenUserData
      captchaAction={"PortalForgottenPasswordFormSubmit"}
      serviceFn={forgottenPassword}
      successMessage={"m.forgotten.password.email.success"}
      pageTitle={"t.page.forgotten.password"}
      submitMessage={"l.btn.forgotten.password"}
    />
  );
};
export default ForgottenPassword;
